/* ==========================================================================
   AL FOUZ Homepage Section — Interactions
   ========================================================================== */
document.addEventListener('DOMContentLoaded', function () {
  var root = document;
 
  /* ---------- Preloader ---------- */
  var preloader = root.querySelector('.af-preloader');
  if (preloader) {
    window.addEventListener('load', function () {
      setTimeout(function () { preloader.classList.add('is-loaded'); }, 300);
    });
  }
 
  /* ---------- Mobile menu toggle (hook into theme menu drawer if present) ---------- */
  root.querySelectorAll('[data-af-menu-toggle]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var drawer = root.querySelector('.header__drawer, #menu-drawer, [data-menu-drawer]');
      if (drawer && drawer.showModal) { drawer.showModal(); }
    });
  });
 
  /* ---------- Search toggle ---------- */
  root.querySelectorAll('[data-af-search-toggle]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var panel = root.querySelector('[data-af-search-panel]');
      if (!panel) return;
      panel.classList.toggle('is-open');
      if (panel.classList.contains('is-open')) {
        var input = panel.querySelector('input[type="search"]');
        if (input) input.focus();
      }
    });
  });
 
  /* ---------- Scroll reveal ---------- */
  var revealEls = root.querySelectorAll('[data-af-reveal]');
  if ('IntersectionObserver' in window && revealEls.length) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.15, rootMargin: '0px 0px -40px 0px' });
    revealEls.forEach(function (el) { io.observe(el); });
  } else {
    revealEls.forEach(function (el) { el.classList.add('is-visible'); });
  }
 
  /* ---------- Countdown timer ---------- */
  root.querySelectorAll('[data-af-countdown]').forEach(function (box) {
    var hours = parseFloat(box.getAttribute('data-af-countdown')) || 12;
    var endTime = Date.now() + hours * 60 * 60 * 1000;
    var elH = box.querySelector('[data-af-h]');
    var elM = box.querySelector('[data-af-m]');
    var elS = box.querySelector('[data-af-s]');
 
    function pad(n) { return String(n).padStart(2, '0'); }
 
    function tick() {
      var diff = endTime - Date.now();
      if (diff <= 0) {
        endTime = Date.now() + hours * 60 * 60 * 1000; // loop the offer
        diff = endTime - Date.now();
      }
      var h = Math.floor(diff / 3600000);
      var m = Math.floor((diff % 3600000) / 60000);
      var s = Math.floor((diff % 60000) / 1000);
      if (elH) elH.textContent = pad(h);
      if (elM) elM.textContent = pad(m);
      if (elS) elS.textContent = pad(s);
    }
    tick();
    setInterval(tick, 1000);
  });
 
  /* ---------- Gallery lightbox ---------- */
  var lightbox = root.querySelector('[data-af-lightbox-modal]');
  var lightboxImg = root.querySelector('[data-af-lightbox-img]');
  if (lightbox && lightboxImg) {
    root.querySelectorAll('[data-af-lightbox]').forEach(function (img) {
      img.addEventListener('click', function () {
        lightboxImg.src = img.currentSrc || img.src;
        lightboxImg.style.display = 'block';
        lightbox.classList.add('is-open');
        document.body.style.overflow = 'hidden';
      });
    });
    var closeLightbox = function () {
      lightbox.classList.remove('is-open');
      document.body.style.overflow = '';
    };
    root.querySelectorAll('[data-af-lightbox-close]').forEach(function (btn) {
      btn.addEventListener('click', closeLightbox);
    });
    lightbox.addEventListener('click', function (e) {
      if (e.target === lightbox) closeLightbox();
    });
  }
 
  /* ---------- Video modal ---------- */
  var videoModal = root.querySelector('[data-af-video-modal]');
  if (videoModal) {
    root.querySelectorAll('[data-af-open-video]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        videoModal.classList.add('is-open');
        var media = videoModal.querySelector('video');
        if (media) media.play().catch(function () {});
        document.body.style.overflow = 'hidden';
      });
    });
    var closeVideo = function () {
      videoModal.classList.remove('is-open');
      var media = videoModal.querySelector('video');
      if (media) media.pause();
      document.body.style.overflow = '';
    };
    root.querySelectorAll('[data-af-video-close]').forEach(function (btn) {
      btn.addEventListener('click', closeVideo);
    });
    videoModal.addEventListener('click', function (e) {
      if (e.target === videoModal) closeVideo();
    });
  }
 
  /* ---------- Before / After compare slider ---------- */
  root.querySelectorAll('.af-compare').forEach(function (compare) {
    var handle = compare.querySelector('[data-af-compare-handle]');
    var afterPanel = compare.querySelector('.af-compare__panel--after');
    if (!handle || !afterPanel) return;
    var dragging = false;
 
    function setPosition(clientX) {
      var rect = compare.getBoundingClientRect();
      var pct = Math.min(100, Math.max(0, ((clientX - rect.left) / rect.width) * 100));
      handle.style.left = pct + '%';
      afterPanel.style.clipPath = 'inset(0 0 0 ' + pct + '%)';
    }
 
    handle.addEventListener('mousedown', function () { dragging = true; });
    handle.addEventListener('touchstart', function () { dragging = true; }, { passive: true });
    window.addEventListener('mouseup', function () { dragging = false; });
    window.addEventListener('touchend', function () { dragging = false; });
    window.addEventListener('mousemove', function (e) { if (dragging) setPosition(e.clientX); });
    window.addEventListener('touchmove', function (e) {
      if (dragging && e.touches[0]) setPosition(e.touches[0].clientX);
    }, { passive: true });
  });
 
  /* ---------- FAQ accordion ---------- */
  root.querySelectorAll('[data-af-faq-toggle]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var item = btn.closest('.af-faq__item');
      if (!item) return;
      var wasOpen = item.classList.contains('is-open');
      item.parentElement.querySelectorAll('.af-faq__item').forEach(function (i) {
        i.classList.remove('is-open');
      });
      if (!wasOpen) item.classList.add('is-open');
    });
  });
 
  /* ---------- Sticky mobile buy bar ---------- */
  var stickyBuy = root.querySelector('.af-stickybuy');
  var hero = root.querySelector('.af-hero');
  if (stickyBuy && hero && 'IntersectionObserver' in window) {
    var heroObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        stickyBuy.classList.toggle('is-visible', !entry.isIntersecting && entry.boundingClientRect.top < 0);
      });
    }, { threshold: 0 });
    heroObserver.observe(hero);
  }
});